<template>
  <div class="">
    <b-modal
      ref="modal-primary "
      id="modal-primary"
      modal-class="modal-primary"
      centered
      size="xl"
      title="Rapor Detayı"
      hide-footer
    >
      <div id="invoice-page">
        <div class="items-center justify-between">
          <div class="items-center">
            <vs-tabs style="height: 450px" alignment="fixed">
              <vs-tab label="Cari">
                <div>
                  <b-card-text>
                    <vs-card>
                      <div slot="header">
                        <h3></h3>
                      </div>
                      <b-row style="margin-bottom: 10px">
                        <b-col lg="3" sm="6">
                          <ButtonPrimary
                            :title="filtretitle"
                            :size="filtresize"
                            @test-click="resetStateFatura"
                            :color="filtrecolor"
                          />
                        </b-col>
                      </b-row>
                      <ag-grid-vue
                        style="width: 100%; height: 300px"
                        class="ag-theme-alpine"
                        :rowSelection="rowSelection"
                        :defaultColDef="defaultColDef"
                        :columnDefs="columnDefs"
                        :rowData="rowData"
                        :localeText="localeText"
                        :pagination="true"
                        @grid-ready="onGridReady"
                        @first-data-rendered="onFirstDataRendered"
                      >
                      </ag-grid-vue>
                    </vs-card>
                  </b-card-text>
                </div>
              </vs-tab>
              <vs-tab active label="Fatura">
                <div>
                  <b-card-text>
                    <vs-card>
                      <div slot="header">
                        <h3></h3>
                      </div>
                      <b-row style="margin-bottom: 10px">
                        <b-col lg="3" sm="6">
                          <ButtonPrimary
                            :title="filtretitle"
                            :size="filtresize"
                            @test-click="resetStateFaturaAy"
                            :color="filtrecolor"
                          />
                        </b-col>
                      </b-row>
                      <ag-grid-vue
                        style="width: 100%; height: 300px"
                        class="ag-theme-alpine"
                        :defaultColDef="defaultColDef"
                        :columnDefs="columnDefsFatura"
                        :rowData="rowDataFatura"
                        :localeText="localeText"
                        :pagination="true"
                        @grid-ready="onGridReadyFatura"
                        @first-data-rendered="onFirstDataRendered"
                      >
                      </ag-grid-vue>
                    </vs-card>
                  </b-card-text>
                </div>
              </vs-tab>
            </vs-tabs>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import {
  BButton,
  BModal,
  VBModal,
  BFormDatepicker,
  BTabs,
  BTab,
  BCardText,
} from "bootstrap-vue";
import Store from "../../../../store/store";
import state from "../../../../store/state";
import ButtonPrimary from "../global-components/ButtonPrimary.vue";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import moment from "moment";
import ExcelYazdirComponent from "../ExcelYazdirComponent.vue";
import FinansalRaporDetayButon from "./FinansalRaporDetayButon.vue";

export default {
  components: {
    ButtonPrimary,
    ExcelYazdirComponent,
    BFormDatepicker,
    BButton,
    BModal,
    BTabs,
    BTab,
    BCardText,
    AgGridVue,
    FinansalRaporDetayButon,
  },

  directives: {
    "b-modal": VBModal,
  },
  data() {
    return {
      filtresize: "small",
      filtretitle: "Filtrelemeyi Resetle",
      filtrecolor: "success",
      rowSelection: null,
      size: "small",
      title: "Listele",
      faizOran: "",
      cariEkstreList: [],
      hareketTuruListesi: [],
      stokHareketListesi: [],
      bakiyeYaslandırmaListesi: [],
      cariHareketlerListesi: [],
      excelYadirData: [],
      ACTNAME: "",
      datepickerbaslangic: "",
      datepickerbitis: "",
      ACTID: "",
      localeText: null,
      dir: false,
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      columnDefs: null,
      columnDefsFatura: null,
      rowDataFatura: null,
      rowData: null,
      YIL: "",
      AY: "",
      CARI: "",
    };
  },
  created() {
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
    this.rowSelection = "single";
  },
  methods: {
    resetStateFaturaAy() {
      this.gridApi.setFilterModel(null);
      this.gelenfiltre = "";
      this.rpAcikFaturalarDetayAylik();
    },
    resetStateFatura() {
      this.gridApi.setFilterModel(null);
      this.gelenfiltre = "";
      this.rpAcikFaturalarDetay();
    },
    currencyFormatter(currency, sign) {
      var sansDec = currency.toFixed(2);
      var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return sign + `${formatted}`;
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      //  this.rpAcikFaturalarDetay();
    },
    onGridReadyFatura(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.rpAcikFaturalarDetayAylik();
    },
    rowStyleClassFn(row) {
      return "VGT-row";
    },
    listele() {
      this.stokHareketList();
      this.cariHareketlerList();
    },
    formatDate(tarih) {
      return moment(String(tarih)).format("DD.MM.YYYY");
    },
    rpAcikFaturalarDetayAylik() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        YIL: vm.YIL,
        AY: vm.AY,
      };
      soap.createClient(url, function (err, client) {
        client.rpAcikFaturaAylarFaturaDetay(args, function (err, result) {
          if (result.rpAcikFaturaAylarFaturaDetayResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.rpAcikFaturaAylarFaturaDetayResult);
          vm.rowDataFatura = vm.veriler;
        });
      });
    },
    parseDate(params) {
      return moment(String(params.value)).format("DD.MM.YYYY");
    },

    rpAcikFaturalarDetay(data) {
      this.$refs["modal-primary "].show();
      var vm = this;
      vm.YIL = data.YIL;
      vm.AY = data.AY;
      vm.CARI = data.ACTNAME;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
        YIL: vm.YIL,
        AY: vm.AY,
      };
      soap.createClient(url, function (err, client) {
        client.rpAcikFaturaAylarFirmaDetay(args, function (err, result) {
          if (result.rpAcikFaturaAylarFirmaDetayResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.rpAcikFaturaAylarFirmaDetayResult);
          vm.rowData = vm.veriler;
        });
      });
      vm.rpAcikFaturalarDetayAylik();
    },
    direction() {
      this.dir = false;
      return this.dir;
    },
  },
  beforeMount() {
    this.columnDefs = [
      {
        width: 100,
        field: "",
        cellRendererFramework: "FinansalRaporDetayButon",
      },
      {
        headerName: "Cari No",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        field: "ACCNO",
      },
      {
        headerName: "Cari Adı",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "YIL",
        field: "YIL",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "AY",
        field: "AY",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },

      {
        headerName: "TUTAR",
        field: "TUTAR",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: (params) =>
          this.currencyFormatter(params.data.TUTAR, "₺"),
        type: "rightAligned",
      },
    ];
    this.columnDefsFatura = [
      {
        headerName: "Cari No",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        field: "ACTNO",
      },
      {
        headerName: "Cari Adı",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Belge No",
        field: "DOCUMENTNO",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Vade Tarihi",
        field: "DUEDATE",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: this.parseDate,
      },
      {
        headerName: "Tarih",
        field: "TRANSDATE",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: this.parseDate,
      },

      {
        headerName: "TUTAR",
        field: "FaturaTutar",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: (params) =>
          this.currencyFormatter(params.data.FaturaTutar, "₺"),
        type: "rightAligned",
      },
      {
        headerName: "Yeni Bakiye",
        field: "YeniBakiye",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: (params) =>
          this.currencyFormatter(params.data.YeniBakiye, "₺"),
        type: "rightAligned",
      },
      {
        headerName: "Fark Gün",
        field: "farkgun",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
    ];
  },
};
</script>
<style lang="scss">
#modal-primary___BV_modal_outer_ {
  z-index: 105000 !important;
}
[dir="ltr"] .modal .modal-header,
[dir="rtl"] .modal .modal-header {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
}
[dir] .modal .modal-header {
  background-color: #f8f8f8;
  border-bottom: none;
}
[dir="ltr"] .modal-header,
[dir="rtl"] .modal-header {
  border-top-left-radius: calc(0.358rem - 1px);
  border-top-right-radius: calc(0.358rem - 1px);
}
[dir] .modal-header {
  padding: 0.8rem 1.4rem;
  border-bottom: 1px solid #ebe9f1;
}

[dir="ltr"] .modal .modal-header .close:active,
[dir="ltr"] .modal .modal-header .close:focus,
[dir="ltr"] .modal .modal-header .close:hover {
  -webkit-transform: translate(5px, 3px);
  transform: translate(5px, 3px);
}

[dir] .modal .modal-header .close:active,
[dir] .modal .modal-header .close:focus,
[dir] .modal .modal-header .close:hover {
  -webkit-box-shadow: none;
  box-shadow: none;
}
.modal.modal-primary .modal-header .close {
  color: #7367f0 !important;
}
.modal .modal-header .close:active,
.modal .modal-header .close:focus,
.modal .modal-header .close:hover {
  opacity: 1;
  outline: none;
}
[dir="ltr"] .modal-header .close {
  margin: -0.8rem -1.4rem -0.8rem auto;
}
[dir] .modal .modal-header .close {
  padding: 0.2rem 0.62rem;
  -webkit-box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  box-shadow: 0 5px 20px 0 rgb(34 41 47 / 10%);
  border-radius: 0.357rem;
  background: #fff;
}
.modal-header {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: start;
  -ms-flex-align: start;
  align-items: flex-start;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
}
[dir] button:not(:disabled),
[dir] [type="button"]:not(:disabled),
[dir] [type="reset"]:not(:disabled),
[dir] [type="submit"]:not(:disabled) {
  cursor: pointer;
  border: none;
}
.con-vs-popup .vs-popup {
  width: 900px;
}
.VGT-row:hover {
  background-color: rgb(187, 185, 185);
}
</style>